import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  registrationContainer: {
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "575px",
    minHeight: "229px",
    border: "1px solid #CCCCCC",
    padding: "24px",
    borderRadius: "4px",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    "& button": {
      padding: "0px 16px",
      width: "255.5px",
      fontWeight: 700,
      height: "40px",

      cursor: "pointer",

      background: "#00843D",
      borderRadius: "2px",

      color: "white",
      border: 0,
      outline: 0,
    },
  },
  whatDoYouWantToDo: {
    fontFamily: "Helvetica Neue",
    fontWeight: 700,
    fontSize: "16px",
    padding: 0,
    textAlign: "left",
    lineHeight: "125%",
    letterSpacing: "0.01em",
    color: "#666666",
  },
  goBack: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    "& h6": {
      color: "#666",
      fontSize: "14px",
      fontWeight: 400,
    },
    "& a": {
      color: "#007582",
      textDecoration: 'none',
      fontWeight: 700,
      marginLeft: "5px",
    },
  },
  dividerText: {
    color: "#999999",
  },
}));

export default useStyles;
